{
  "id": 8,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 5,
  "goals": [
    { "type": "mud" }
  ],
  "stars": [2270, 3800],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . X . . X . .",
    ". . x . . x . .",
    ". . x . . x . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.936, "movesLeft": 4.5, "closeLosses": 0.052, "target": 0.92 }
}
